var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoverStructureNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179089",
    transform: "translate(-82 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(82 164)",
    style: {
      fill: "#f3f6fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179085"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 89",
    d: "M17238.609 11085a.6.6 0 0 1-.611-.6v-14.8a.6.6 0 0 1 .611-.6h14.781a.6.6 0 0 1 .609.6v14.808a.6.6 0 0 1-.609.6zm10.658-1.2h3.52v-7.164h-3.52zm-5.318 0h4.1v-7.164h-4.1zm-4.736 0h3.523v-7.164h-3.523zm0-8.36h13.574v-5.246h-13.574z",
    transform: "translate(-17147.999 -10897.002)",
    style: {
      fill: "#231f20"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverStructureNewIcon);
export default __webpack_public_path__ + "static/media/hover_structure_new_icon.3a0fbe55ff536286f5f4282484493962.svg";
export { ForwardRef as ReactComponent };